import React from 'react';
import { Banner } from '../Banner/Banner';
import { Button } from '@alchemer/ui/components/button';
import { ArrowRightFromLine, TriangleAlert } from '@alchemer/ui/icons';
import { tw } from '@/lib/tailwind';

interface ImpersonationBannerProps {
  userName: string;
  onExit: () => void;
}

export function ImpersonationBanner({ userName, onExit }: ImpersonationBannerProps) {
  return (
    <Banner className="border-warning-600 bg-warning-300">
      <div className={tw('flex flex-1 items-center justify-center gap-2')}>
        <TriangleAlert className="h-3.5 w-3.5" />
        <span className="font-bold text-gray-900 uppercase">Caution:</span>
        <span className="flex items-center gap-2 text-gray-900">
          You are currently impersonating {userName}
          <svg
            width="21"
            height="21"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.142 6.00028C13.142 3.71243 11.2881 1.85717 9.00028 1.85686C6.71224 1.85686 4.85686 3.71224 4.85686 6.00028C4.85715 8.14529 6.48753 9.9101 8.57673 10.1219L9.00028 10.142L9.42383 10.1219C11.5125 9.90959 13.1417 8.14491 13.142 6.00028ZM20.1431 18.0003C20.1431 14.9383 18.3017 12.0486 16.4852 10.6861C16.2694 10.5242 16.142 10.2695 16.142 9.99972C16.142 9.72996 16.2694 9.47523 16.4852 9.31334C17.0298 8.90468 17.4663 8.36844 17.7542 7.7514C18.0419 7.13439 18.1727 6.45576 18.1359 5.77595C18.099 5.09597 17.8945 4.43479 17.5416 3.8524C17.1887 3.27036 16.6973 2.78334 16.1119 2.43611C15.7054 2.19445 15.5711 1.66941 15.8122 1.26256C16.0537 0.855397 16.5803 0.721402 16.9874 0.962891C17.8153 1.45401 18.5092 2.14191 19.0081 2.96512C19.507 3.78844 19.7964 4.72262 19.8485 5.68387C19.9005 6.64485 19.7146 7.60411 19.3078 8.47628C19.0502 9.02835 18.7075 9.53401 18.2966 9.97796C20.1852 11.7671 21.8574 14.7647 21.8574 18.0003C21.8571 18.4732 21.4732 18.8571 21.0003 18.8574C20.5271 18.8574 20.1435 18.4734 20.1431 18.0003ZM14.8563 6.00028C14.8561 7.98829 13.8647 9.74293 12.3502 10.8016C13.4296 11.2428 14.4225 11.8963 15.2631 12.7369C16.924 14.3979 17.8563 16.6508 17.8563 18.9997C17.8563 19.4731 17.4725 19.8569 16.9992 19.8569C16.526 19.8566 16.142 19.4729 16.142 18.9997C16.142 17.1054 15.3904 15.2885 14.0511 13.9489C12.7116 12.6095 10.8945 11.8565 9.00028 11.8563C7.10601 11.8563 5.28902 12.6096 3.9495 13.9489C2.60995 15.2885 1.85686 17.1053 1.85686 18.9997C1.85686 19.4731 1.47311 19.8569 0.999721 19.8569C0.526334 19.8569 0.142578 19.4731 0.142578 18.9997C0.142578 16.6507 1.07641 14.3979 2.73744 12.7369C3.57747 11.8969 4.56843 11.2427 5.64704 10.8016C4.13339 9.74282 3.14276 7.98763 3.14258 6.00028C3.14258 2.76547 5.76547 0.142578 9.00028 0.142578C12.2348 0.14288 14.8563 2.76565 14.8563 6.00028Z"
              className="fill-foreground-950"
            />
          </svg>
        </span>
      </div>
      <Button
        className={tw(
          'text-primary flex cursor-pointer items-center gap-1 bg-transparent whitespace-nowrap hover:bg-transparent',
        )}
        onClick={onExit}
      >
        Exit Impersonation <ArrowRightFromLine className="h-3.5 w-3.5" />
      </Button>
    </Banner>
  );
}
